import React from 'react'

import Reflux from 'reflux-react-16'
import moment from 'moment'
import _ from 'lodash'
import aSync from 'async'

import OrderStore from '../../stores/OrderStore.js'
import ParcelStore from '../../stores/ParcelStore.js'
import ParcelActions from '../../actions/ParcelActions.js'
import UserStore from '../../stores/UserStore.js'
import CustomerStore from '../../stores/CustomerStore.js'
import AddressStore from '../../stores/AddressStore.js'

import ViewParcelModal from '../../components/parcels/ViewParcelModal.js'
import EditParcelModal from '../../components/parcels/EditParcelModal.js'
import ImportParcels from '../../components/parcels/ImportParcels.js'
import {fromLabelCallback, printLabels} from '../../components/labels/printLabels.js'
import NewParcel from '../../../server/functions/parcels/NewParcel.js'
import {hasNoTrackTrace} from '../../../server/functions/parcels/trackTrace.js'
import {getCarrierLabel} from '../../components/parcels/CarrierLogo.js'
import EditPricePopup from '../../components/parcels/EditPricePopup.js'
import OrderScanModal from '../../components/orders/OrderScanModal.js'
import {Button, Colors, SplitButton, IconButton, S2, P, Panel, Popup, PdfModal, Icon, ToolTip} from '../../components/UI/index.js'
import CarrierLogo from '../../components/parcels/CarrierLogo.js'
import ChangeParcelStatusPopup from '../../components/parcels/ChangeParcelStatusPopup.js'
import dbCodes from '../../../server/dbCodes.js'
import Table from '../../components/UI/table/index.js'
import SearchBar from '../../components/SearchBar/index.js'
import csvExport from '../../utils/csvExport.js'
import filter from '../../utils/filter.js'
import {formatGrams} from '../../../utils/utils.js'
import {formatPrice, parsePrice} from '../../../utils/price.js'
import webshopNames from '../../utils/webshopNames.js'
import t from 'src/helpers/Languages.js'
import branchesAvailable from '@utils/branchesAvailable.js'
import {formSpacing} from '../../components/UI/forms/index.js'
import createMemo from '../../utils/createMemo.js'
import {trackTraceLink} from '../../../utils/trackTraceLink.js'

class Parcels extends Reflux.Component {
    constructor(props) {
        super(props)

        this.columnsMemo = createMemo()

        this.state = {printerPageSize: localStorage.printerPageSize || 'A6'}

        this.stores = [ParcelStore, OrderStore, UserStore, CustomerStore, AddressStore]
    }

    componentDidMount() {
        const {reseller} = this.props
        const {parcelId = ''} = this.props.match.params

        document.title = `Zendingen • ${reseller.settings.accountName || reseller.name}`

        if (this.props.location?.state?.parcelId) {
            this.onClickView(this.props.location?.state?.parcelId)
        }

        if (parcelId) {
            this.viewParcelModal.open(parcelId)
        }

        window.history.replaceState({}, '')
    }

    componentDidUpdate() {
        if (this.state.parcelLimitWarning) {
            this.setState({parcelLimitWarning: false})
            this.alertPopup.openAlert('Waarschuwing', 'Je huidige datumrange bevat meer dan 35 000 zendingen, hierdoor worden niet alle zendingen weergegeven. Verklein de datumrange om dit te voorkomen. ')
        }
    }

    // The same columns until a value they read changes: new columns re-render every row of the table
    columns() {
        return this.columnsMemo([this.props.reseller, this.state.customers, this.state.carriers], () => this.buildColumns())
    }

    buildColumns() {
        const {reseller} = this.props

        return [
            ...branchesAvailable(reseller) ?
                [{id: 'branchName', title: t('branch'), visible: false, key: 'branchName', width: 180, text: (parcel) => {
                    const branch = reseller.settings.branches?.find((branch) => branch.id === parcel?.branchId)
                    return branch?.name || ''
                }}] :
                [],
            {id: 'date', title: 'Datum', visible: true, width: 120, key: 'date', sort: (parcel) => {
                return `${parcel.date} ${parcel.timeConfirmed}`
            }, render: (parcel) => {
                return (
                    <div style={{width: '100%'}}>
                        <P ellipsis>{parcel.date ? moment(parcel.date).format('DD-MM-YYYY') : ''}</P>
                        <S2 ellipsis>{parcel.timeConfirmed}</S2>
                    </div>
                )
            }},
            {id: 'customer', title: 'Klant', visible: true, flex: 1, key: 'customer', sort: (parcel) => {
                return this.state.customers[parcel.customer] ? this.state.customers[parcel.customer].name : ''
            }, text: (parcel) => {
                return this.state.customers[parcel.customer] ? this.state.customers[parcel.customer].name : ''
            }},
            {id: 'address', title: 'Adres', visible: true, key: 'address', sort: (parcel, option) => {
                return parcel.address[option]
            }, dropdown: {
                legacyKey: 'addressSortOption',
                defaultValue: 'postalCode',
                options: [
                    {
                        label: 'Naam',
                        value: 'name'
                    },
                    {
                        label: 'Straat',
                        value: 'street'
                    },
                    {
                        label: 'Huisnummer',
                        value: 'nr'
                    },
                    {
                        label: 'Postcode',
                        value: 'postalCode'
                    },
                    {
                        label: 'Plaats',
                        value: 'city'
                    }
                ]
            }, flex: 2, render: (parcel) => {
                const address = parcel.address

                return (
                    <div style={{width: '100%'}}>
                        <P ellipsis>{address.name}</P>

                        <div style={{display: 'flex', alignItems: 'center'}}>
                            {address.postalCode && address.country === 'NL' && address.showWarning &&
                                <ToolTip text='Adres niet gevonden. Controleer de gegevens voor je bevestigt.'>
                                    <Icon size='md' style={{marginRight: 6, color: Colors.errorBright}} icon='mdi mdi-alert' />
                                </ToolTip>
                            }

                            <S2 style={{flex: 1}} ellipsis>{`${address.street} ${address.nr}${address.addition} ${address.postalCode} ${address.city}`}</S2>
                        </div>
                    </div>
                )
            }},
            {id: 'address.country', title: 'Land', visible: true, width: 75, key: 'address.country'},
            {id: 'address.isBusiness', title: 'Bedrijfsadres', visible: false, width: 150, key: 'address.isBusiness', text: (parcel) => {
                return parcel.address.isBusiness ? 'Ja' : 'Nee'
            }},
            {id: 'reference', title: 'Referentie', visible: true, width: 200, key: 'reference'},
            {id: 'comment', title: 'Bezorginstructie', visible: false, flex: 1, key: 'comment'},
            {id: 'notes', title: 'Notities', visible: false, flex: 1, key: 'notes'},
            {id: 'weight', title: 'Gewicht', visible: false, width: 100, key: 'weight', text: (parcel) => {
                return `${formatGrams(parcel.weight)} kg`
            }},
            {id: 'length', title: 'Lengte', visible: false, width: 100, key: 'length', text: (parcel) => {
                return `${(parcel.length || 0) / 10} cm`
            }},
            {id: 'width', title: 'Breedte', visible: false, width: 100, key: 'width', text: (parcel) => {
                return `${(parcel.width || 0) / 10} cm`
            }},
            {id: 'height', title: 'Hoogte', visible: false, width: 100, key: 'height', text: (parcel) => {
                return `${(parcel.height || 0) / 10} cm`
            }},
            {id: 'category', title: 'Categorie', visible: false, width: 150, key: 'category', text: (parcel) => {
                return parcel.priceExplanation?.product?.category || ''
            }},
            {id: 'options', title: 'Opties', visible: true, width: 250, key: 'options', text: (parcel) => {
                return parcel.options.join(', ')
            }},
            {id: 'fees', title: 'Toeslagen', visible: false, flex: 2, key: 'fees', text: (parcel) => {
                const fees = parcel.fees.map((fee) => {
                    if (fee.quantity === 1) {
                        return fee.description
                    } else {
                        return `${fee.quantity}x ${fee.description}`
                    }
                })

                return fees.join(', ')
            }},
            {id: 'price', title: 'Prijs', visible: false, width: 100, key: 'price', sort: (parcel) => {
                if (parcel.price === 'priceScale') {
                    return parsePrice(parcel.priceScaleRange?.min)
                }

                let price = parsePrice(parcel.price)

                parcel.fees.map((fee) => {
                    if (typeof fee.price === 'string' && fee.price) {
                        price += parsePrice(fee.price) * fee.quantity
                    }
                })

                return price
            }, text: (parcel) => {
                if (parcel.price === 'priceScale') {
                    if (parcel.priceScaleRange) {
                        return `€ ${parcel.priceScaleRange.min} - € ${parcel.priceScaleRange.max}`
                    }

                    return `n.t.b.`
                }

                let price = parsePrice(parcel.price)

                parcel.fees.map((fee) => {
                    if (typeof fee.price === 'string' && fee.price) {
                        price += parsePrice(fee.price) * fee.quantity
                    }
                })

                return `€ ${formatPrice(price)}`
            }},
            {id: 'productCodes', title: 'Productcodes', visible: false, width: 150, key: 'productCodes', text: (parcel) => {
                const productCodes = parcel.productCodes.map((item) => {
                    if (item.quantity === 1) {
                        return item.productCode
                    } else {
                        return `${item.quantity}x ${item.productCode}`
                    }
                })

                parcel.fees.map((fee) => {
                    if (fee.productCode) {
                        if (fee.quantity === 1) {
                            productCodes.push(fee.productCode)
                        } else {
                            productCodes.push(`${fee.quantity}x ${fee.productCode}`)
                        }
                    }
                })

                return productCodes.join(', ')
            }},
            {id: 'carrier', title: 'Vervoerder', visible: true, width: 200, key: 'carrier', render: (parcel) => {
                return <CarrierLogo size={40} carriers={this.state.carriers} value={parcel.carrier} options={parcel.options} />
            }},
            {id: 'carrierName', title: 'Vervoerder naam', width: 200, key: 'carrier', text: (parcel) => {
                const carrier = this.state.carriers.find((carrier) => carrier.name === parcel.carrier)

                return (carrier && getCarrierLabel(carrier, parcel.options).displayName) || parcel.carrier.split('-')[0] || ''
            }},
            {id: 'platform', title: 'Platform', width: 200, key: 'platform', text: (parcel) => {
                return this.state.carriers.find((carrier) => carrier.name === parcel.carrier)?.platform || parcel.carrier.split('-')[1] || ''
            }, sort: (parcel) => {
                return this.state.carriers.find((carrier) => carrier.name === parcel.carrier)?.platform || parcel.carrier.split('-')[1] || ''
            }},
            {id: 'trackTrace', title: 'Track & Trace', visible: true, width: 220, key: 'trackTrace', onClick: (parcel) => {
                if (hasNoTrackTrace(parcel)) {
                    return
                }

                if (parcel.trackTraceLink.indexOf('veloyd') > -1) {
                    window.open(trackTraceLink(parcel.trackTrace, parcel.address))
                } else {
                    window.open(parcel.trackTraceLink)
                }
            }},
            {id: 'externId', title: 'Externe ID', visible: false, width: 100, key: 'externId', text: (parcel) => {
                if (['GLS', 'Skynet'].includes(parcel.carrier)) {
                    return parcel.externId
                }
            }},
            {id: 'plugin', title: 'Koppeling', visible: false, width: 150, key: 'plugin', text: (parcel) => {
                let plugin = parcel.plugin || parcel.webshop || ''

                if (webshopNames[plugin]) {
                    return webshopNames[plugin]
                }

                if (plugin && !['API', 'CSV'].includes(plugin)) {
                    plugin = _.capitalize(plugin)
                }

                return plugin
            }},
            {id: 'status', title: 'Status', visible: true, width: 150, key: 'status', text: (parcel) => {
                return dbCodes.parcelStatus[parcel.status]
            }},
            {id: 'invoiced', title: 'Gefactureerd', visible: false, width: 150, key: 'invoiced', text: (parcel) => {
                return parcel.invoiced ? 'Ja' : 'Nee'
            }},
            {id: 'createdBy', title: 'Aangemaakt door', visible: false, width: 150, key: 'createdBy'},
            {id: 'actions', visible: true, width: 50, showOnHover: true, render: (parcel) => {
                if (parcel.status === dbCodes.parcelStatus.aangemaakt()) {
                    return (
                        <IconButton onClick={this.onClickEdit.bind(this, parcel)}>
                            <i className='mdi mdi-pencil' />
                        </IconButton>
                    )
                } else {
                    return (
                        <IconButton onClick={this.onClickView.bind(this, parcel._id)}>
                            <i className='mdi mdi-eye' />
                        </IconButton>
                    )
                }
            }}
        ]
    }

    onChangeDates(parcelStartDate, parcelEndDate) {
        ParcelActions.setDates(parcelStartDate, parcelEndDate)
    }

    onChangeQueries(parcelQueries) {
        this.table.selectPage(1)
        ParcelActions.setQueries(parcelQueries)
    }

    onTableChange(selectedParcels) {
        ParcelActions.setSelected(selectedParcels)
    }

    onClickNew() {
        this.editParcelModal.open()
        ParcelActions.setSelected([])
    }

    onClickEdit(parcel) {
        this.editParcelModal.open(parcel)
    }

    onClickView(id) {
        this.viewParcelModal.open(id)
    }

    onClickImport() {
        this.importModal.open()
        ParcelActions.setSelected([])
    }

    async onClickExport() {
        const {selectedParcels, parcels, parcelStartDate, parcelEndDate, customers, carriers} = this.state
        const {reseller} = this.props

        const parcelsById = _.keyBy(parcels, '_id')
        const selected = selectedParcels.map((id) => parcelsById[id])

        await this.popup.openProgress(t('export'), '', (onProgress) => csvExport.parcels(false, selected, parcelStartDate, parcelEndDate, reseller, customers, carriers, onProgress))

        ParcelActions.setSelected([])
    }

    async onClickCopy(id, multiple, options) {
        const {parcels, selectedParcels, customers} = this.state
        id = id || selectedParcels[0]
        let parcel = _.find(parcels, (parcel) => parcel._id === id)
        parcel = JSON.parse(JSON.stringify(parcel))

        const copyParcel = () => {
            const newParcel = NewParcel()

            const customer = customers[parcel.customer]

            if (customer) {
                newParcel.customer = parcel.customer
                newParcel.contact = parcel.contact
            }

            newParcel.address = parcel.address
            newParcel.emailTT = parcel.emailTT
            newParcel.reference = parcel.reference
            newParcel.comment = parcel.comment
            newParcel.weight = parcel.weight
            newParcel.height = parcel.height
            newParcel.width = parcel.width
            newParcel.length = parcel.length
            newParcel.options = options || parcel.options

            if (parcel.cover) {
                newParcel.cover = parcel.cover
            }
            if (parcel.deliveryTime) {
                newParcel.deliveryTime = parcel.deliveryTime
            }
            if (parcel.pickupDate) {
                newParcel.pickupDate = parcel.pickupDate
            }
            if (parcel.pickupAddress) {
                newParcel.pickupAddress = parcel.pickupAddress
            }
            if (parcel.pickupPoint) {
                newParcel.pickupPoint = parcel.pickupPoint
            }

            newParcel.carrier = parcel.carrier

            if (parcel.customs) {
                newParcel.customs = parcel.customs
            }

            return newParcel
        }

        if (multiple) {
            const popupInput = {
                label: 'Aantal kopieën',
                value: 1,
                type: 'number',
                min: 1,
                max: 99

            }
            this.popup.setInput(popupInput)
            const inputValue = await this.popup.open('Kopieer meerdere keren', '')
            if (inputValue === undefined) return

            popupInput.value = inputValue
            popupInput.disabled = true
            this.popup.setInput(popupInput)

            this.popup.setProgress(0, inputValue)

            let success = 0
            const errors = []

            for (let i = 0; i < inputValue; i++) {
                const newParcel = copyParcel()

                await new Promise((resolve) => {
                    ParcelActions.create(newParcel, (err) => {
                        if (err) {
                            errors.push(err)
                        } else {
                            success += 1
                        }

                        this.popup.setProgress(success + errors.length, inputValue)
                        resolve()
                    })
                })
            }
            this.popup.setMessage(`${success} ${success === 1 ? 'zending' : 'zendingen'} gekopieerd.`)
            this.popup.setErrors(errors)
        } else {
            const newParcel = copyParcel()

            this.editParcelModal.open(newParcel)
        }

        ParcelActions.setSelected([])
    }

    onClickRemove() {
        const {selectedParcels} = this.state

        this.popup.open('Zendingen verwijderen', 'Zendingen met status Aangemaakt worden verwijderd.', () => {
            ParcelActions.setSelected([])

            let success = 0
            const errors = []

            this.popup.setProgress(0, selectedParcels.length)

            aSync.eachSeries(selectedParcels, (id, next) => {
                ParcelActions.remove(id, (err) => {
                    if (err) {
                        errors.push(err)
                    } else {
                        success += 1
                    }

                    this.popup.setProgress(success + errors.length, selectedParcels.length)

                    next()
                })
            }).then(() => {
                this.popup.setMessage(`${success} ${success === 1 ? 'zending' : 'zendingen'} verwijderd.`)
                this.popup.setErrors(errors)
            })
        })
    }

    onClickCancel() {
        const {selectedParcels} = this.state

        this.popup.open('Zendingen annuleren', 'Zendingen met status Opgehaald worden geannuleerd.', () => {
            ParcelActions.setSelected([])

            let success = 0
            const errors = []
            const warnings = []

            this.popup.setProgress(0, selectedParcels.length)

            aSync.eachSeries(selectedParcels, (id, next) => {
                ParcelActions.cancel(id, (err, warning) => {
                    if (err) {
                        errors.push(err)
                    } else {
                        success += 1
                    }

                    if (warning) {
                        warnings.push(warning)
                    }

                    this.popup.setProgress(success + errors.length, selectedParcels.length)

                    next()
                })
            }).then(() => {
                this.popup.setMessage(`${success} ${success === 1 ? 'zending' : 'zendingen'} geannuleerd.`)
                this.popup.setErrors(errors)
                this.popup.setWarnings(warnings)
            })
        })
    }

    onClickPrintLabels(id) {
        const {selectedParcels, parcels, printerPageSize} = this.state

        const ids = id ? [id] : selectedParcels

        printLabels({
            ids,
            printerPageSize,
            printPopup: this.printPopup,
            pdfModal: this.pdfModal,
            print: (ids, nrOfEmptyLabels) => fromLabelCallback((callback) => ParcelActions.printLabels(ids, nrOfEmptyLabels, callback)),
            text: 'Zendingen worden bevestigd en kunnen niet meer worden gewijzigd.',
            itemName: 'zendingen',
            onPrint: () => ParcelActions.setSelected([]),
            warning: {
                popup: this.popup,
                title: 'Foutieve adressen',
                text: 'Eén of meer van de geselecteerde zendingen heeft een onbekende combinatie van postcode/straatnaam + huisnummer. Wil je toch doorgaan met het printen van de labels?',
                show: () => parcels.filter((parcel) => ids.includes(parcel._id)).some(({address}) => address.postalCode && address.country === 'NL' && address.showWarning)
            },
            batchProgressMessages: false,
            hideProgressAtSetStart: true
        })
    }

    onChangePrinterPageSize(event) {
        localStorage.printerPageSize = event.target.value
        this.setState({printerPageSize: event.target.value})
    }

    onClickScan() {
        this.scanModal.open()
    }

    onClickCalculatePrice() {
        const {selectedParcels} = this.state

        this.editPricePopup.open((fees, removeOldFees, pricingOption, newPrice) => {
            let success = 0
            const errors = []

            ParcelActions.setSelected([])

            this.editPricePopup.setProgress(0, selectedParcels.length)

            aSync.eachSeries(selectedParcels, (id, next) => {
                if (this.editPricePopup?.state?.stopOperation) return
                ParcelActions.calculatePrice(id, fees, removeOldFees, pricingOption, newPrice, (err) => {
                    if (err) {
                        errors.push(err)
                    } else {
                        success += 1
                    }

                    this.editPricePopup.setProgress(success + errors.length, selectedParcels.length)

                    next()
                })
            }).then(() => {
                this.editPricePopup.setMessage(`${success} ${success === 1 ? 'zending' : 'zendingen'} herberekend.`)
                this.editPricePopup.setErrors(errors)
            })
        })
    }

    onOpenChangeParcelStatus() {
        const {selectedParcels} = this.state
        this.changeParcelStatusPopup.open((newStatus) => {
            this.setState({loading: true})
            let success = 0
            const errors = []

            this.changeParcelStatusPopup.setProgress(0, selectedParcels.length)

            ParcelActions.setSelected([])
            aSync.eachSeries(selectedParcels, (id, next) => {
                ParcelActions.changeStatus(id, newStatus, (err) => {
                    if (err) {
                        errors.push(err)
                    } else {
                        success += 1
                    }

                    this.changeParcelStatusPopup.setProgress(success + errors.length, selectedParcels.length)

                    next()
                })
            }).then(() => {
                this.changeParcelStatusPopup.setMessage(`${success} ${success === 1 ? 'zending' : 'zendingen'} gewijzigd.`)
                this.changeParcelStatusPopup.setErrors(errors)
            })
        })
    }

    async onClickAddOptions() {
        const {selectedParcels} = this.state
        const {reseller} = this.props

        let enabledOptions = (_.keys(reseller.settings.parcels.products) || []).filter((product) => {
            return _.some(_.keys(reseller.settings.parcels.products[product]), (carrier) => {
                return reseller.settings.parcels.products[product][carrier]
            })
        }).sort()

        // filter out postbus and antwoordnummer
        enabledOptions = enabledOptions.filter((option) => !['Postbus', 'Antwoordnummer'].includes(option))

        enabledOptions = enabledOptions.map((option) => {
            return {value: option, title: option}
        })

        this.popup.setInputs([
            {
                label: 'Verzendopties',
                info: 'Als een combinatie van opties niet mogelijk is wordt de voorkeur gegeven aan de eerst geselecteerde optie.',
                noSort: true,
                name: 'options',
                values: [],
                type: 'select',
                options: enabledOptions
            },
            {
                label: 'Verzendopties vervangen',
                name: 'replace',
                value: false,
                type: 'checkbox'
            }
        ])

        const values = await this.popup.open('Verzendopties toevoegen', 'Kies de verzendopties die toegevoegd moeten worden.')
        if (!values) return
        ParcelActions.setSelected([])

        const options = values.options
        const replace = !!values.replace

        let success = 0
        const errors = []

        this.popup.setProgress(0, selectedParcels.length)

        aSync.eachSeries(selectedParcels, (id, next) => {
            ParcelActions.addOptions(id, options, replace, (err) => {
                if (err) {
                    errors.push(err)
                } else {
                    success += 1
                }

                this.popup.setProgress(success + errors.length, selectedParcels.length)

                next()
            })
        }).then(() => {
            this.popup.setMessage(`${success} ${success === 1 ? 'zending' : 'zendingen'} bewerkt.`)
            this.popup.setErrors(errors)
        })
    }

    render() {
        const {parcelStartDate, parcelEndDate, selectedParcels, parcelsLoading, parcelQueries, usersObject, filteredOrders, routes, carriers, customers, addressBook, printerPageSize} = this.state
        const {reseller, history, user} = this.props
        const parcels = filter.parcels(this.state.parcels, parcelQueries, carriers, reseller)

        return (
            <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
                <Panel style={{display: 'flex', columnGap: formSpacing.columnGap, borderTop: 'none', borderLeft: 'none', borderRight: 'none', background: Colors.backgroundNeutral, padding: '20px 10px 10px 10px'}}>

                    <SearchBar
                        columns={this.columns()}
                        onQueryChange={this.onChangeQueries.bind(this)}
                        onDateChange={this.onChangeDates.bind(this)}
                        startDate={parcelStartDate}
                        endDate={parcelEndDate}
                        queries={parcelQueries}
                    />

                    <Button
                        variant='outline-white'
                        onClick={this.onClickNew.bind(this)}
                    >Nieuwe Zending
                    </Button>

                    <Button
                        variant='outline-white'
                        onClick={this.onClickImport.bind(this)}
                        tooltip='Importeer zendingen'
                    >
                        <i className='mdi mdi-file-import' />
                    </Button>

                    <Button
                        variant='outline-white'
                        onClick={this.onClickScan.bind(this)}
                        tooltip='Scannen'
                    >
                        <i className='mdi mdi-barcode-scan' />
                    </Button>

                    {selectedParcels.length > 0 &&
                        <>
                            <Button
                                variant='outline-white'
                                onClick={this.onClickExport.bind(this)}
                                tooltip='Exporteer zendingen'
                            >
                                <i className='mdi mdi-file-export' />
                            </Button>

                            {selectedParcels.length === 1 &&
                                <>
                                    <SplitButton
                                        variant='outline-white'
                                        onClick={() => this.onClickCopy()}
                                        tooltip='Kopieer zending'
                                        options={[
                                            {title: 'Kopieer meerdere keren', action: () => {
                                                this.onClickCopy(undefined, true)
                                            }}
                                        ]}
                                    >
                                        <i className='mdi mdi-content-copy' />
                                    </SplitButton>
                                </>
                            }

                            <SplitButton
                                variant='outline-white'
                                value={printerPageSize}
                                options={[
                                    {title: 'Papierformaat A6', value: 'A6'},
                                    {title: 'Papierformaat 10x21', value: '10x21'},
                                    {title: 'Papierformaat A5', value: 'A5'},
                                    {title: 'Papierformaat A4 | 4x A6', value: 'A4'},
                                    {title: 'Papierformaat A4 | 3x 10x21', value: 'A410x21'},
                                    {title: 'Papierformaat A4 | 2x A5', value: 'A4A5'}
                                ]}
                                onChange={this.onChangePrinterPageSize.bind(this)}
                                onClick={() => this.onClickPrintLabels()}
                                tooltip='Print zending labels'
                            >
                                <i className='mdi mdi-printer' />
                            </SplitButton>

                            <Button
                                variant='outline-white'
                                onClick={this.onClickCalculatePrice.bind(this)}
                                tooltip='Prijs aanpassen'
                            >
                                <i className='mdi mdi-currency-eur' />
                            </Button>

                            <Button
                                variant='outline-white'
                                onClick={() => this.onClickAddOptions()}
                                tooltip='Verzendopties toevoegen'
                            >
                                <i className='mdi mdi-package-variant-closed' />
                            </Button>

                            {selectedParcels.length === 1 &&
                                <>
                                    <Button
                                        variant='outline-white'
                                        tooltip='Retourneer zending'
                                        onClick={() => {
                                            this.onClickCopy(selectedParcels[0], false, ['Retour'])
                                        }}
                                        icon='mdi mdi-keyboard-return'
                                    />
                                </>
                            }

                            <Button
                                variant='outline-white'
                                onClick={this.onClickRemove.bind(this)}
                                tooltip='Verwijderen'
                            >
                                <i className='mdi mdi-delete' />
                            </Button>

                            <Button
                                variant='outline-white'
                                onClick={this.onClickCancel.bind(this)}
                                tooltip='Annuleren'
                            >
                                <i className='mdi mdi-close-circle' />
                            </Button>

                            <Button
                                variant='outline-white'
                                onClick={this.onOpenChangeParcelStatus.bind(this)}
                            >
                                Status wijzigen
                            </Button>
                        </>
                    }
                </Panel>

                <div style={{flex: 1, marginTop: 24, marginRight: 24, marginLeft: 24}}>
                    <Table
                        tableName='parcels'
                        columns={this.columns()}
                        rows={parcels}
                        selectedRows={selectedParcels}
                        loading={parcelsLoading}
                        onChange={this.onTableChange.bind(this)}
                        ref={(ref) => this.table = ref}
                    />
                </div>

                <ImportParcels
                    reseller={reseller}
                    user={user}
                    carriers={carriers}
                    customers={customers}
                    ref={(modal) => this.importModal = modal}
                />

                <ViewParcelModal
                    history={history}
                    match={this.props.match}
                    reseller={reseller}
                    user={user}
                    carriers={carriers}
                    customers={customers}
                    onClickCopy={this.onClickCopy.bind(this)}
                    onClickPrintLabels={this.onClickPrintLabels.bind(this)}
                    ref={(modal) => this.viewParcelModal = modal}
                />

                <EditParcelModal
                    reseller={reseller}
                    user={user}
                    carriers={carriers}
                    customers={customers}
                    addressBook={addressBook}
                    pdfModal={this.pdfModal}
                    ref={(modal) => this.editParcelModal = modal}
                />

                <Popup ref={(ref) => this.popup = ref} />
                <Popup ref={(ref) => this.alertPopup = ref} />
                <Popup ref={(ref) => this.printPopup = ref} />
                <PdfModal ref={(ref) => this.pdfModal = ref} />
                <EditPricePopup reseller={reseller} ref={(ref) => this.editPricePopup = ref} />
                <ChangeParcelStatusPopup ref={(ref) => this.changeParcelStatusPopup = ref} />

                <OrderScanModal
                    user={user}
                    history={history}
                    customers={customers}
                    users={usersObject}
                    carriers={carriers}
                    reseller={reseller}
                    routes={routes}
                    filteredOrders={filteredOrders}
                    printerPageSize={printerPageSize}
                    ref={(ref) => this.scanModal = ref}
                />
            </div>
        )
    }
}

export default (Parcels)
